<ng-container *ngIf="showHeader">
    <img class="banner-img center-block div-print" src="https://gestionatupyme-public.s3.amazonaws.com/banner.png"
        alt="" />
</ng-container>

<mat-card class="simple-card mx-auto">
    <mat-card-content>
        <div class="row">

            <div class="col-12 d-flex justify-content-between" *ngIf="showHeader">
                <h1>Reporte F301</h1>
                <button
                    mat-flat-button
                    class="custom-button-primary no-print"
                    (click)="generatePDF()"
                    [disabled]="isPDFLoading">
                    <mat-icon aria-hidden="false" aria-label="Icono de descarga" fontIcon="get_app" class="icon-download"></mat-icon>
                    Descargar Resultado
                    <mat-icon *ngIf="isPDFLoading" iconPositionEnd>
                        <mat-spinner class="custom-white-spinner" diameter="15"></mat-spinner>
                    </mat-icon>
                </button>
            </div>

            <div class="col-12 my-3" *ngIf="showHeader">
                <mat-chip-set aria-label="Rut principal">
                    <mat-chip class="chip-rut">
                        <strong>RUT:</strong> {{content.DatosBasicosSolicitud.Rut | number:'1.0-0'}}-{{content.DatosBasicosSolicitud.DV | uppercase}}
                    </mat-chip>
                </mat-chip-set>
            </div>

            <div class="col-12">
                <mat-card class="mt-5 no-break">
                    <mat-card-header>
                        <mat-card-title class="font-size-title-card">
                            <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                            <strong>Antecedentes</strong>
                        </mat-card-title>
                    </mat-card-header>

                    <mat-card-content>
                        <div class="p-5">
                            <div class="border grid p-5">
                                <div class="font-weight-bold full-width">Empleador</div>

                                <div class="font-weight-500">Rut empresa:</div>
                                <div>{{ antecedentes.empleador.rut | rutFormat }}</div>

                                <div class="font-weight-500">Razón social:</div>
                                <div>{{ antecedentes.empleador.razonSocial }}</div>

                                <div class="font-weight-500">Representante legal:</div>
                                <div>{{ antecedentes.empleador.representanteLegal.nombre }}</div>

                                <div class="font-weight-500">Rut representante legal:</div>
                                <div>{{ antecedentes.empleador.representanteLegal.rut | rutFormat}}</div>

                                <div class="font-weight-500">Actividad económica:</div>
                                <div>{{ antecedentes.empleador.codigoActividadEconomica }}</div>

                                <div class="font-weight-500">Correo:</div>
                                <div>{{ antecedentes.empleador.email }}</div>

                                <div class="font-weight-500">Teléfono:</div>
                                <div>{{ antecedentes.empleador.phone }}</div>

                            </div>
                        </div>

                        <div class="p-5">
                            <div class="border grid p-5">
                                <div class="font-weight-bold full-width">Dirección empleador</div>

                                <div class="font-weight-500">Región:</div>
                                <div>{{ antecedentes.empleador.location.region }}</div>

                                <div class="font-weight-500">Comuna:</div>
                                <div>{{ antecedentes.empleador.location.comuna }}</div>

                                <div class="font-weight-500">Calle:</div>
                                <div>{{ antecedentes.empleador.location.calle }}</div>

                                <div class="font-weight-500">Número:</div>
                                <div>{{ antecedentes.empleador.location.numero }}</div>

                                <div class="font-weight-500">Departamento:</div>
                                <div>{{ antecedentes.empleador.location.departamento }}</div>

                            </div>
                        </div>

                        <div class="p-5">
                            <div class="border grid p-5">
                                <div class="font-weight-bold full-width">Empresa principal</div>

                                <div class="font-weight-500">Rut empresa:</div>
                                <div>{{ antecedentes.empresaPrincipal.rut | rutFormat }}</div>

                                <div class="font-weight-500">Razón social:</div>
                                <div>{{ antecedentes.empresaPrincipal.razonSocial }}</div>

                                <div class="font-weight-500">Representante legal:</div>
                                <div>{{ antecedentes.empresaPrincipal.representanteLegal.nombre }}</div>

                                <div class="font-weight-500">Rut representante legal:</div>
                                <div>{{ antecedentes.empresaPrincipal.representanteLegal.rut | rutFormat }}</div>

                            </div>
                        </div>

                        <div class="p-5">
                            <div class="border grid p-5">
                                <div class="font-weight-bold full-width">Dirección empresa principal</div>

                                <div class="font-weight-500">Región:</div>
                                <div>{{ antecedentes.empresaPrincipal.location.region }}</div>

                                <div class="font-weight-500">Comuna:</div>
                                <div>{{ antecedentes.empresaPrincipal.location.comuna }}</div>

                                <div class="font-weight-500">Calle:</div>
                                <div>{{ antecedentes.empresaPrincipal.location.calle }}</div>

                                <div class="font-weight-500">Número:</div>
                                <div>{{ antecedentes.empresaPrincipal.location.numero }}</div>

                            </div>
                        </div>

                    </mat-card-content>
                </mat-card>

                <mat-card class="mt-5 no-break">
                    <mat-card-header>
                        <mat-card-title class="font-size-title-card">
                            <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                            <strong>Obra</strong>
                        </mat-card-title>
                    </mat-card-header>

                    <mat-card-content>
                        <div class="p-5">
                            <div class="border grid p-5">
                                <div class="font-weight-bold full-width">Datos básicos</div>

                                <div class="font-weight-500">Nombre:</div>
                                <div>{{ obra.nombre }}</div>

                                <div class="font-weight-500">Modo participación:</div>
                                <div>{{ obra.modoParticipacion }}</div>

                                <div class="font-weight-500">Tipo:</div>
                                <div>{{ obra.tipo }}</div>

                                <div class="font-weight-500">Empresa principal:</div>
                                <div>{{ obra.empresaPrincipal }}</div>

                            </div>
                        </div>

                        <div class="p-5">
                            <div class="border grid p-5">
                                <div class="font-weight-bold full-width">Dirección empresa principal</div>

                                <div class="font-weight-500">Región:</div>
                                <div>{{ obra.location.region }}</div>

                                <div class="font-weight-500">Comuna:</div>
                                <div>{{ obra.location.comuna }}</div>

                                <div class="font-weight-500">Calle:</div>
                                <div>{{ obra.location.calle }}</div>

                                <div class="font-weight-500">Número:</div>
                                <div>{{ obra.location.numero }}</div>

                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>

                <mat-card class="mt-5 no-break">
                    <mat-card-header>
                        <mat-card-title class="font-size-title-card">
                            <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                            <strong>Períodos</strong>
                        </mat-card-title>
                    </mat-card-header>

                    <mat-card-content>
                        <div class="p-5">
                            <div class="border grid p-5">
                                <div class="font-weight-bold full-width">Datos básicos</div>

                                <div class="font-weight-500">Objetivo certificado:</div>
                                <div>{{ periodos.objetivoCertificado }}</div>

                                <div class="font-weight-500">Institución recaudadora:</div>
                                <div>{{ periodos.institucionRecaudadora }}</div>

                                <div class="font-weight-500">Período:</div>
                                <div>{{ periodos.periodo }}</div>
                            </div>
                        </div>

                        <div class="p-5">
                            <div class="border grid p-5">
                                <div class="font-weight-bold full-width">Trabajadores</div>

                                <div class="font-weight-500">Vigentes:</div>
                                <div>{{ periodos.trabajadores.vigentes }}</div>

                                <div class="font-weight-500">Despedidos:</div>
                                <div>{{ periodos.trabajadores.despedidos }}</div>
                            </div>
                        </div>

                        <div class="p-5">
                            <div class="border grid p-5">
                                <div class="font-weight-bold full-width">Cotizaciones previsionales</div>

                                <div class="font-weight-500">Pagadas:</div>
                                <div>{{ periodos.cotizacionesPrevisionales.pagadas }}</div>

                                <div class="font-weight-500">Adjunta nómina:</div>
                                <div>{{ periodos.cotizacionesPrevisionales.adjuntaNomina }}</div>
                            </div>
                        </div>

                        <div class="p-5">
                            <div class="border grid p-5">
                                <div class="font-weight-bold full-width">Remuneraciones</div>

                                <div class="font-weight-500">Pagadas:</div>
                                <div>{{ periodos.remuneraciones.pagadas }}</div>

                                <div class="font-weight-500">No pagadas:</div>
                                <div>{{ periodos.remuneraciones.noPagadas }}</div>

                                <div class="font-weight-500">Monto informado:</div>
                                <div>{{ periodos.remuneraciones.montoInformado }}</div>
                            </div>
                        </div>

                        <div class="p-5">
                            <div class="border grid p-5">
                                <div class="font-weight-bold full-width">Indemnización sustitutiva aviso previo</div>

                                <div class="font-weight-500">Pagadas:</div>
                                <div>{{ periodos.indemnizacionSustitutivaAvisoPrevio.pagadas }}</div>

                                <div class="font-weight-500">No pagadas:</div>
                                <div>{{ periodos.indemnizacionSustitutivaAvisoPrevio.noPagadas }}</div>

                                <div class="font-weight-500">Monto informado:</div>
                                <div>{{ periodos.indemnizacionSustitutivaAvisoPrevio.montoInformado }}</div>
                            </div>
                        </div>

                        <div class="p-5">
                            <div class="border grid p-5">
                                <div class="font-weight-bold full-width">Indemnización por años de servicio</div>

                                <div class="font-weight-500">Pagadas:</div>
                                <div>{{ periodos.indemnizacionPorAniosDeSevicio.pagadas }}</div>

                                <div class="font-weight-500">No pagadas:</div>
                                <div>{{ periodos.indemnizacionPorAniosDeSevicio.noPagadas }}</div>

                                <div class="font-weight-500">Monto informado:</div>
                                <div>{{ periodos.indemnizacionPorAniosDeSevicio.montoInformado }}</div>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>

                <mat-card class="mt-5 no-break">
                    <mat-card-header>
                        <mat-card-title class="font-size-title-card">
                            <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                            <strong>Certificado</strong>
                        </mat-card-title>
                    </mat-card-header>

                    <mat-card-content>
                        <div class="p-5">
                            <div class="border grid p-5">
                                <div class="font-weight-bold full-width">Datos básicos</div>

                                <div class="font-weight-500">Período:</div>
                                <div>{{ certificado.periodo }}</div>

                                <div class="font-weight-500">Ámbito:</div>
                                <div>{{ certificado.ambito }}</div>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>

            <div class="col-12 mt-5 mb-3 no-break">
                <mat-card>
                    <mat-card-header>
                        <mat-card-title class="font-size-title-card">
                            <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                            <strong>Trabajadores declarados</strong>
                        </mat-card-title>
                    </mat-card-header>

                    <mat-card-content>

                        <div class="row p-5">
                            <div class="col-12 border mx-auto px-0">

                                <div class="table-responsive">
                                    <table mat-table [dataSource]="trabajadoresDeclaradosDataSource" class="custom-print-table">
                                        <ng-container matColumnDef="rut">
                                            <th mat-header-cell *matHeaderCellDef>Rut</th>
                                            <td mat-cell *matCellDef="let element">{{ element.rut | rutFormat }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="nombre">
                                            <th mat-header-cell *matHeaderCellDef>Nombre</th>
                                            <td mat-cell *matCellDef="let element">{{ element.nombre }}</td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="trabajadoresDeclaradosDisplayedColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: trabajadoresDeclaradosDisplayedColumns;"></tr>

                                        <tr class="mat-mdc-row" *matNoDataRow>
                                            <td class="mat-mdc-cell text-center font-weight-500" [attr.colspan]="trabajadoresDeclaradosDisplayedColumns.length">
                                                No hay datos disponibles
                                            </td>
                                        </tr>
                                    </table>
                                </div>

                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>

        </div>
    </mat-card-content>
</mat-card>